import * as React from 'react';
import { InjectedFormProps } from 'redux-form';
import { IAuthState } from '../../../../../../services/auth/models';
import { IBrandingActions, IBrandingState } from '../../../../../../services/branding/models';
import { IMtaActions, IMtaFormNames, IMtaState } from '../../../../../../services/mta/models';
import { ICustomerMTAOptions } from '../../index';
import { find, forEach, get } from 'lodash';
import { canToleratePremium } from '../../../../../../helpers/Mta';
import { isLuckyTripProduct } from '../../../../../../helpers/TravelApplication';
import Heap from '../../../../../../helpers/Heap';

interface IRedirectToMtaProps extends InjectedFormProps<any> {
  auth: IAuthState;
  branding: IBrandingState;
  mta: IMtaState;
  customerMTAOptions: ICustomerMTAOptions;
  match: any;
  mtaPolicy: any;
  dispatch: any;
  actions: {
    push(path: string);
    reset(formName: string);
    destroy(formName: string);
    mta: IMtaActions;
    branding: IBrandingActions;
  };
}

interface IRedirectState {
  allowedMta: boolean;
  loading: boolean;
}

export class RedirectCommon extends React.Component<IRedirectToMtaProps, IRedirectState> {

  constructor(props) {
    super(props);
    this.state = {
      allowedMta: true,
      loading: false,
    };
    this.resetForms();
  }

  componentDidMount(settings: string) {
    const { customerMTAOptions } = this.props;
    this.setState({ loading: true });

    if (!get(customerMTAOptions, settings, false)) {
      this.setState({ loading: false, allowedMta: false });
      return;
    }

  }

  private resetForms = () => {
    const { actions } = this.props;
    forEach(IMtaFormNames, (value) => {
      actions.reset(value);
      actions.destroy(value);
    });
    actions.mta.resetMtaData();
  }

  protected checkErrors = (redirectURL: string) => {
    const { dispatch, change, mtaPolicy, actions } = this.props;
    Promise.resolve(dispatch(change('data.attributes', mtaPolicy))).then(() => {
      actions.mta.calculateMtaPremiums().then(() => {
        this.checkPremiumMismatch();
        this.checkRenewal();
        this.checkClaim(redirectURL);
        this.setState({ loading: false });
      }).catch(() => {
        this.setState({ loading: false });
      });
    })
  }

  private checkRenewal = () => {
    const { mta } = this.props;
    const hasRenewal = get(mta, 'policyInfo.meta.hasRenewal', false);
    this.setState({ allowedMta: !hasRenewal })
  }

  private checkPremiumMismatch = () => {
    const { actions } = this.props;
    const selectedScheme = actions.mta.getSelectedScheme();
    const grossPremium = get(selectedScheme, 'premium.gross');
    if (selectedScheme && canToleratePremium(grossPremium) === false) {
      this.setState({ allowedMta: false });
    } else if (!selectedScheme) {
      this.setState({ allowedMta: false });
    }
  }

  private checkClaim = (redirectURL: string) => {
    const { auth, match } = this.props;
    const { allowedMta } = this.state;
    const claim = find(auth.policyClaims, ['attributes.policy_id', match.params.id])
    if (get(claim, 'id', null) !== null) {
      this.setState({ allowedMta: false })
      this.setState({ loading: false });
    } else {
      if (allowedMta) {
        this.setSelectedPolicy(match.params.id, true, redirectURL);
      }
    }
  }

  private setSelectedPolicy = (policyId, track = false, redirectURL: string): void => {
    const { auth, actions } = this.props;
    let selectedPolicy = null;
    if (get(auth, 'customer.activePolicies', []).length) {

      forEach(auth.customer.activePolicies, (policySelected) => {
        if (policySelected.id === policyId) {
          selectedPolicy = policySelected;
        }
      });

      if (selectedPolicy && !isLuckyTripProduct(selectedPolicy)) {
        Promise.resolve(actions.mta.setSelectedPolicy(selectedPolicy)).then(() => {
          actions.mta.getPolicyInfo();
          this.setState({ loading: false });
          actions.push(redirectURL)
          if (track) {
            Heap.trackEvent('MtaJourneyStart', selectedPolicy, 'policy')
          }
        });
      } else {
        this.props.actions.push(`/account/policies/${policyId}`);
      }
    }
  }

  protected renderNotAllowedMta = () => {
    return RedirectCommon.renderNotAllowedMTAStatic();
  }

  static renderNotAllowedMTAStatic = () => {
    return (
      <>
        <h1>Whoops!</h1>
        <p>Unfortunately, we have been unable to make the change you have requested.</p>
        <p>Please contact us in order to make the change and keep your policy up to date. Details on how to contact us
          can be found
          <a target={'_blank'} href={'https://www.admiral.com/contact-us/travel'}> here </a>
        </p>
        <p>It is important that your details are kept up to date, as incorrect information could invalidate your cover
          or affect any future claims.</p>
      </>
    )
  }

}
